<template>
  <div>
    <form autocomplete="off" @submit.prevent="onSubmit($event)">
      <!-- Company name -->
      <div class="form-group row" :class="state('name')">
        <label for="company-name" class="col-md-3">
          Įmonės pavadinimas
        </label>
        <div class="col-md-9">
          <input
            type="text"
            class="form-control mw-100"
            id="company-name"
            name="company-name"
            placeholder=""
            v-model="model.name"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('name')"
        v-if="state('name')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('name') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- Email -->
      <div class="form-group row" :class="state('email')">
        <label for="email" class="col-md-3">Įmonės el. pašto adresas:</label>
        <div class="col-md-9">
          <input
            type="email"
            name="email"
            class="form-control"
            id="email"
            v-model="model.email"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('email')"
        v-if="state('email')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('email') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- Phone -->
      <div class="form-group row" :class="state('phone')">
        <label for="phone" class="col-md-3">Įmonės telefono numeris:</label>
        <div class="col-md-9">
          <input
            type="text"
            class="form-control"
            id="phone"
            name="phone"
            v-model="model.phone"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('phone')"
        v-if="state('phone')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('phone') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- Country -->
      <div class="form-group row" :class="state('country_code')">
        <label for="country_code" class="col-md-3">Šalis</label>
        <div class="col-md-9">
          <multiselect
            class="input-m-select input-h-select"
            v-model="model.country"
            track-by="code"
            label="asciiname"
            placeholder=""
            :options="countries"
            :searchable="true"
            :allow-empty="true"
            :multiple="false"
            autocomplete="off"
            @input="setCountry"
            @select="setCountry"
            @remove="removeCountry"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.asciiname }} ({{ option.name }})</strong>
              <img
                class="option__img option__img-selected-right country-flag"
                :src="getFlag(option.icode)"
                :alt="option.name"
              />
            </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc">
                <span class="option__title">{{ props.option.asciiname }}</span>
                <span class="option__small">({{ props.option.name }})</span>
              </div>
              <img
                class="option__img option__img-right country-flag"
                :src="getFlag(props.option.icode)"
                :alt="props.option.name"
              />
            </template>
            <template slot="caret" slot-scope="{ toggle }">
              <div @mousedown.prevent.stop="toggle" class="toggle-hold">
                <font-awesome-icon
                  :icon="['fa', 'chevron-down']"
                ></font-awesome-icon>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('country_code')"
        v-if="state('country_code')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('country_code') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- City -->
      <div class="form-group row" :class="state('adr_city')">
        <label for="adr_city" class="col-md-3">Miestas:</label>
        <div class="col-md-9">
          <input
            type="text"
            name="adr_city"
            class="form-control"
            id="adr_city"
            v-model="model.adr_city"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('adr_city')"
        v-if="state('adr_city')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('adr_city') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- Street -->
      <div class="form-group row" :class="state('adr_street')">
        <label for="adr_street" class="col-md-3">Gatvė:</label>
        <div class="col-md-9">
          <input
            type="text"
            name="adr_street"
            class="form-control"
            id="adr_street"
            v-model="model.adr_street"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('adr_street')"
        v-if="state('adr_street')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('adr_street') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- House no -->
      <div class="form-group row" :class="state('adr_no')">
        <label for="adr_city" class="col-md-3">
          Namo numeris / Buto numeris:
        </label>
        <div class="col-md-9">
          <input
            type="text"
            name="adr_no"
            class="form-control"
            id="adr_no"
            v-model="model.adr_no"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('adr_no')"
        v-if="state('adr_no')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('adr_no') }}
          </b-form-feedback>
        </div>
      </div>
      <!-- Postal code -->
      <!--      <div class="form-group row" :class="state('adr_zip')">
        <label for="adr_city" class="col-md-3">Pašto kodas:</label>
        <div class="col-md-9">
          <input
            type="text"
            name="adr_zip"
            class="form-control"
            id="adr_zip"
            v-model="model.adr_zip"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('adr_zip')"
        v-if="state('adr_zip')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('adr_zip') }}
          </b-form-feedback>
        </div>
      </div>-->
      <!-- Company code -->
      <!--      <div class="form-group row" :class="state('company_code')">
        <label for="adr_city" class="col-md-3">Company code:</label>
        <div class="col-md-9">
          <input
            type="text"
            name="company_code"
            class="form-control"
            id="company_code"
            v-model="model.company_code"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('company_code')"
        v-if="state('company_code')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('adr_ccompany_codeity') }}
          </b-form-feedback>
        </div>
      </div>-->
      <!-- Vat NO -->
      <!--      <div class="form-group row" :class="state('vat_no')">
        <label for="phone" class="col-md-3">VAT number:</label>
        <div class="col-md-9">
          <input
            type="text"
            class="form-control"
            id="vat_no"
            name="vat_no"
            v-model="model.vat_no"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('vat_no')"
        v-if="state('vat_no')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('vat_no') }}
          </b-form-feedback>
        </div>
      </div>-->
      <!-- Website -->
      <div class="form-group row" :class="state('website')">
        <label for="adr_city" class="col-md-3">Internetinė svetainė:</label>
        <div class="col-md-9">
          <input
            type="text"
            name="website"
            class="form-control mw-100"
            id="website"
            v-model="model.website"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        class="form-validation row"
        :class="state('website')"
        v-if="state('website')"
      >
        <div class="col-md-3"></div>
        <div class="col-md-9">
          <b-form-feedback>
            {{ feedback('website') }}
          </b-form-feedback>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <button type="submit" class="btn blue">Saugoti</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import form from '@core/js/mixins/form'
import Multiselect from 'vue-multiselect'

export default {
  title: '',
  name: 'CompanyData',
  components: { Multiselect },
  mixins: [form],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    countries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      modelName: 'company',
      resourceRoute: 'companies',
      listPath: '/account/company',
      routePath: '/account/company',
      createPath: '/account/companies',
      updatePath: '/account/companies',
      isModal: this.modal,
      isBusy: false
    }
  },
  computed: {
    model() {
      return this.$store.getters['company/data']
    }
  },
  watch: {},
  beforeMount() {
    if (this.isNew) {
      this.$store.commit('company/emptyFields')
    } else {
      this.$store.commit('company/setData', this.data)
    }
  },
  created() {},
  mounted() {
    //this.$title = this.$t('companies.titles.list')
  },
  methods: {
    setCountry(selectedOption) {
      if (selectedOption) {
        this.model.country_code = selectedOption.code
        this.model.city_id = ''
        this.model.city = ''
        this.cityFieldDisabled = false
      }
    },
    removeCountry() {
      this.model.country_code = ''
      this.model.city_id = ''
      this.model.city = ''
      this.cityFieldDisabled = true
    },
    // gets a flag picture
    getFlag(flagName) {
      try {
        return require(`@main/images/flags/${flagName.toLowerCase()}.svg`)
      } catch (e) {
        return require('@main/images/flags/undefined.svg')
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.country-flag {
  max-width: 30px;
  margin-right: 10px;
  border: 1px solid #eaecf0;
}
</style>
